// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyCjMSqcyCOfvG9yH5yKoWqJLXDGb_bUN5A",
  authDomain: "chatapp-8ce30.firebaseapp.com",
  projectId: "chatapp-8ce30",
  storageBucket: "chatapp-8ce30.appspot.com",
  messagingSenderId: "1075205672317",
  appId: "1:1075205672317:web:b18b28590e6bd4a3aad014",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export { app };

/*
TO_DO
1) Add animations
2) Add CSS finishing touch
3) Testing
4) Deployment
*/
